module.exports = __webpack_public_path__ + "static/img/image017.1cca135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image017.png
// module id = Wb0K
// module chunks = 1